export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.749e58fa.svg";